import { request } from "./verb.services";
import { openNotificationWithIcon } from "../utils/Notification";
import { setLoading, setSubmitting } from "redux/actions/loading.actions";
import queryString from "query-string";

export const validateRestriction = (facilityId, values, orderId) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    const qs = queryString.stringify({
      facilityId,
      orderId,
    });
    return request(
      `Orders/Validate?${qs}`,
      // `Orders/Validate?orderServiceDate=${dateTime}`,
      "post",
      values,
      true
    )
      .then((res) => {
        return { mstatus: true };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          e?.response?.data?.[0] ||
            e?.response?.data?.message ||
            e?.response?.data?.Message ||
            e?.response?.message ||
            e?.message ||
            "Something went wrong"
        );
        return {
          mstatus: false,
          error: e?.response?.data?.[0] || "This order has restrictions",
        };
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};
